import { useEffect, useState, type Dispatch, type SetStateAction } from "react";

function reportStepFragment(stepId: string) {
  return `#report-step-${stepId}`;
}

export function useReportStepOpenState(
  stepId: string,
): [boolean, Dispatch<SetStateAction<boolean>>] {
  const [open, setOpen] = useState(
    () => window.location.hash === reportStepFragment(stepId),
  );

  useEffect(() => {
    if (!open || window.location.hash !== reportStepFragment(stepId)) return;

    const frame = window.requestAnimationFrame(() => {
      document.getElementById(`report-step-${stepId}`)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });

    return () => window.cancelAnimationFrame(frame);
  }, [open, stepId]);

  return [open, setOpen];
}
